import { PaymentLogDetailModel } from './payment.log.detail.model';

export class PagedPaymentLogModel {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: PaymentLogDetailModel[] = [];
}
